import React from 'react';
import Testimonial from './TestimonialSection';
import Breadcrumb from '../../components/Breadcrumb';
import Contact from '../../components/Contact';
import CTA from '../../components/CTA';
import Team from '../home-3/TeamSection';
import Feature from './FeatureSection';
import Work from './WorkSection';
import About from '../home/AboutSection';
import Company from '../home/CompanySection';

import aboutImg from '../../assets/img/about/about-6.png';
import bgImg from '../../assets/img/cta/cta-bg-2.png';
import videoBg from '../../assets/img/video/video-bg-4.png';
import videoImg from '../../assets/img/video/video-bg-6.png';

const HomeMain = () => {
  return (
    <main>
      <Breadcrumb pageTitle="About Us" />

      <About />

      <Feature />

      <Company />

      {/*<Team />*/}

      <Work />

      <CTA ctaBG={bgImg} />
    </main>
  );
};

export default HomeMain;
